import { request } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import type { CustomRequestOptions } from '../types';

async function handleRequest<T>(req: RequestOptions, options?: CustomRequestOptions): Promise<T> {
  if (options?.headers) {
    req.headers = options?.headers;
  }
  if (options?.baseURL) {
    req.url = `${options.baseURL}${req.url}`;
  }
  if (options?.errorHandlers) {
    req.errorHandlers = options.errorHandlers;
  }
  const response: T = await request(req);
  return Promise.resolve(response);
}

export { handleRequest };
